export default {
  namespaced: true,
  state: {
    bonusCreditModal: false,
    streakModal: {
      show: false,
    },
    lockTradeModal: {
      show: false,
    },
    joiningBonusModal: {
      show: false,
    },
  },

  mutations: {
    SET_BONUS_CREDIT_MODAL(state, val) {
      state.bonusCreditModal = val;
    },
    TOGGLE_STREAK_MODAL(state, obj) {
      state.streakModal.show = obj.show ? obj.show : false;
    },
    TOGGLE_LOCK_TRADE_MODAL(state, obj) {
      state.lockTradeModal.show = obj.show ? obj.show : false;
    },
    TOGGLE_JOINING_BONUS_MODAL(state, obj) {
      state.joiningBonusModal.show = obj.show ? obj.show : false;
    },
  },
  actions: {},
};
